import { Role } from "../../../Helpers/AuthorizationDataProvider";

export interface Feedback{
	assignedTo: User
	attachments: string[]
	createdAt: string
	createdBy: User
	description: string
	feedbackType: FeedbackTypes
	id: string
	shortDescription: string
	status: Status
	topics: string[]
}

export interface FeedbackResponse {
	count: number
	feedbacks: Feedback[]
}

export enum FeedbackState {
	Active = "Active",
	Archived = "Archived",
	Spam = "Spam"
}

export enum FeedbackTypes {
	BugReport = 'BugReport',
	FlagOfAbuse = 'FlagOfAbuse',
	GeneralFeedback = 'GeneralFeedback',
	Help = 'Help',
	VideoFeedback = 'VideoFeedback'
}

export enum Status{
	Pending = "InProgress",
	Resolved = "Completed",
	Unassigned = "Unassigned",
}

export interface User{
	firstName: string
	isDeleted: boolean
	isActive: boolean
	imageId: string
	lastName: string
	location: string
	reinvite: boolean
	role: Role
	userId: string
}

export interface Props{
  filters: any
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface TableData {
  assignedTo: User
	createdAt: string
	createdBy: User
	feedbackType: FeedbackTypes
	id: string
	shortDescription: string
	status: Status
}